module.exports = __webpack_public_path__ + "img/english.12457fba.png";